import { Component, Directive, ElementRef, Injector, ChangeDetectionStrategy } from "@angular/core";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    selector: 'settings-directive',
    standalone: false,
})
export class SettingsDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('settings', elementRef, injector);
    }
}

@Component({
    selector: 'settings',
    template: '<settings-directive></settings-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettingsComponent {
}

@Directive({
    selector: 'offline-settings-directive',
    standalone: false,
})
export class OfflineSettingsDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('offlineSettings', elementRef, injector);
    }
}

@Component({
    selector: 'offline-settings',
    template: '<offline-settings-directive></offline-settings-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OfflineSettingsComponent {
}

@Directive({
    selector: 'offline-test-directive',
    standalone: false,
})
export class OfflineTestDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('offlineTest', elementRef, injector);
    }
}

@Component({
    selector: 'offline-test',
    template: '<offline-test-directive></offline-test-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OfflineTestComponent {
}

@Directive({
    selector: 'review-directive',
    standalone: false,
})
export class ReviewDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('review', elementRef, injector);
    }
}

@Component({
    selector: 'review',
    template: '<review-directive></review-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReviewComponent {
}

@Directive({
    selector: 'status-directive',
    standalone: false,
})
export class StatusDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('status', elementRef, injector);
    }
}

@Component({
    selector: 'status',
    template: '<status-directive></status-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatusComponent {
}
